import React from 'react';
const InfoBox = ({ msg, children, type = 'info' }) => (React.createElement(React.Fragment, null, (msg || children) &&
    React.createElement("div", { className: `alert alert-${type}`, role: "alert" }, msg !== null && msg !== void 0 ? msg : '',
        children)));
export default InfoBox;
